import { validateEmail } from '../models/email';
import { authentificationRepository } from '../repositories/authentication-repository';

async function requestOtpByEmail({ email, languageCode }) {
    const validationData = validateEmail(email);

    if (!validationData.isValid) {
        throw Error(validationData.message);
    }

    const data = await authentificationRepository.requestOtpByEmail({ email, languageCode });

    return data;
}

export {
    requestOtpByEmail
};
